package com.nonopn.skydome.common.app.api.impl

import com.nonopn.skydome.common.app.detection.ThunderDetection

// Pure mapping of the admin estimates API to the model displayed by the estimates list.

const val ADMIN_PAYMENT_DEMO = "Demo"
const val ADMIN_PAYMENT_EXTERNAL = "External"
const val ADMIN_PAYMENT_STRIPE = "Stripe"

private const val PROBE_ACTIVE = "Active"

/** The estimate as the list model; the legacy fields stay filled so that the edit screen keeps working. */
fun AdminEstimate.toEstimate(): ThunderDetectionEstimate = ThunderDetectionEstimate(
    uuid = uuid,
    email = account.email ?: account.uuid ?: "",
    probes = probes.map {
        ThunderDetection(
            uuid = it.uuid,
            name = it.name,
            latitude = it.latitude,
            longitude = it.longitude,
            createdAtSecondsUtc = it.createdAtSecondsUtc,
            status = it.status,
            isDemo = it.isDemo,
            enabled = it.status?.let { status -> status == PROBE_ACTIVE },
            validUntilSecondsUtc = it.validUntilSecondsUtc,
        )
    },
    isSkySentinel = app == "SkySentinel",
    isTestStarting = false,
    isExternalContract = payment == ADMIN_PAYMENT_EXTERNAL,
    validUntilSecondsUtc = validUntilSecondsUtc,
    // Stripe estimates have no `active`: the real activation is the one of the probes
    areEnabled = active ?: probes.any { it.status == PROBE_ACTIVE },
    admin = AdminEstimateInfo(
        state = state,
        payment = payment,
        app = app,
        issues = issues,
        createdAtSecondsUtc = createdAtSecondsUtc,
        paymentProduct = paymentProduct,
        subscription = subscription,
    ),
)

/** Only an External estimate can be activated / deactivated by an administrator (PATCH `active`). */
fun ThunderDetectionEstimate.canToggleActive(): Boolean = admin?.payment == ADMIN_PAYMENT_EXTERNAL
